import { addDays } from "../../../domain/time";
import type { LocalDate } from "../../../domain/time";
import type { DateRange } from "../../times/model/period";

/** Days before today whose open absence requests are still listed (retroactive requests). */
export const openRequestsPastDays = 30;

/** Days after today whose open absence requests are listed (together at most 366 days). */
export const openRequestsFutureDays = 335;

/**
 * Returns the range in which open absence requests are looked for: the team's on the manager view
 * (ADR-0110) and the person's own under „Offen“ on „Heute“ (F-78). It reaches back a month, so a
 * request filed afterwards for a past day still counts, and stays within the 366 days the server
 * lists at most.
 *
 * @param today - Today in the time zone of the employment.
 * @returns The inclusive range.
 */
export function openAbsenceRequestRange(today: LocalDate): DateRange {
  const range: DateRange = {
    from: addDays(today, -openRequestsPastDays),
    to: addDays(today, openRequestsFutureDays),
  };

  return range;
}
